export interface GroupLabelProps {
  naslov: string;
  /** „obavezno" / „neobavezno". Bez toga korisnik ne zna smije li preskočiti. */
  oznaka?: string;
}

/**
 * Naziv skupine polja u obrascu.
 *
 * Zamjenjuje `FormStep` — zaglavlje s brojem u krugu. Broj je uveden da kaže
 * kako postoji redoslijed, ali je dao suprotan učinak: četiri numerirana
 * naslova jednake težine na jednom obrascu čitala su se kao obrazac iz ureda i
 * dodala četiri naslova ekranu koji ih nije trebao. Trener o toj inačici:
 * „izgleda nabacano kao da su se djeca igrala."
 *
 * Redoslijed se vidi iz rasporeda; ovaj redak samo imenuje skupinu i kaže smije
 * li se preskočiti. Crta iznad odvaja skupine bez ijedne dodatne plohe.
 */
export function GroupLabel({ naslov, oznaka }: GroupLabelProps) {
  return (
    <div className="flex items-baseline justify-between gap-3 border-t border-line-subtle pt-4">
      <span className="text-[13.5px] font-medium text-ink">{naslov}</span>
      {oznaka && (
        <span className="text-[11.5px] uppercase tracking-[0.08em] text-ink-muted">{oznaka}</span>
      )}
    </div>
  );
}
